import { createSlice } from '@reduxjs/toolkit';
import { fetchData } from '../actions/dataActions';

const initialState = {};

const dataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchData.pending, (state, action) => {
                const { dataKey } = action.meta.arg;
                if (!state[dataKey]) {
                    state[dataKey] = { data: [], loading: false, error: null };
                }
                state[dataKey].loading = true;
                state[dataKey].error = null;
            })
            .addCase(fetchData.fulfilled, (state, action) => {
                const { dataKey } = action.meta.arg;
                state[dataKey].data = action.payload;
                state[dataKey].loading = false;
                state[dataKey].error = null;
            })
            .addCase(fetchData.rejected, (state, action) => {
                const { dataKey } = action.meta.arg;
                state[dataKey].error = action.payload;
                state[dataKey].loading = false;
            });
    },
});

export default dataSlice.reducer;
